import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, BarChart3, UserCheck, Signal, Users } from 'lucide-react';
export function Slide13Learnings() {
  const learnings = [{
    title: 'The QR mechanic worked',
    desc: 'The measurable engagement came primarily through QR access. This means the format successfully converted scan-based curiosity into active participation.',
    icon: QrCode
  }, {
    title: 'The Industry Pulse concept worked',
    desc: 'People were willing to answer strategic questions because the experience felt like benchmarking, not a survey.',
    icon: BarChart3
  }, {
    title: 'The lead quality was strong',
    desc: 'The captured leads came from relevant companies and roles across the radiopharma ecosystem.',
    icon: UserCheck
  }, {
    title: 'The market signal was clear',
    desc: 'The audience consistently pointed toward isotope supply, scientific translation, scientific expertise, integrated capabilities, and supply chain reliability.',
    icon: Signal
  }, {
    title: 'The booth layer was under-activated',
    desc: 'The Snak™ was not fully used as a guided booth conversation tool. iPads, rep links, email, and active staff prompting were underused.',
    icon: Users
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-527">
      <div className="mb-10" data-id="element-528">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-529">
          What SNMMI taught us
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-530">
          The Snak™ proved that the audience will engage when the format feels
          fast, relevant, and peer-based.
        </p>
      </div>

      <div className="flex-1 space-y-4" data-id="element-531">
        {learnings.map((learning, i) => {
        const Icon = learning.icon;
        return <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + i * 0.1
        }} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm flex items-start gap-6 hover:shadow-md transition-shadow" data-id="element-532">
              <div className="p-3 bg-slate-50 text-minerva-blue rounded-xl shrink-0 mt-1" data-id="element-533">
                <Icon className="w-6 h-6" data-id="element-534" />
              </div>
              <div data-id="element-535">
                <h3 className="text-lg font-bold text-slate-800 mb-1" data-id="element-536">
                  Learning {i + 1}: {learning.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-537">
                  {learning.desc}
                </p>
              </div>
            </motion.div>;
      })}
      </div>
    </div>;
}